<template>
  <div class="relative flex flex-col items-center w-96 h-64">
    <!-- SVG con área expandida (260x160) -->
    <svg viewBox="0 0 260 160" class="w-full h-full">
      <defs>
        <filter id="needle-shadow" x="-20%" y="-20%" width="140%" height="140%">
          <feDropShadow dx="0" dy="2" stdDeviation="2" flood-opacity="0.2"/>
        </filter>
      </defs>

      <!-- Grupo contenedor desplazado al centro inferior (130, 130) -->
      <g transform="translate(130, 130)">
        
        <!-- 1. ARCO DE LA BARRA (Estilizado y Esbelto) -->
        <path d="M -90 0 A 90 90 0 0 1 0 -90" fill="none" stroke="#10b981" stroke-width="7" stroke-linecap="round" />
        <path d="M 0 -90 A 90 90 0 0 1 53 -73" fill="none" stroke="#f59e0b" stroke-width="7" />
        <path d="M 53 -73 A 90 90 0 0 1 90 0" fill="none" stroke="#ef4444" stroke-width="7" stroke-linecap="round" />

        <!-- Líneas divisorias internas del arco -->
        <g stroke="#ffffff" stroke-width="1.5" opacity="0.5">
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(18)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(36)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(54)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(72)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(90)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(108)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(126)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(144)" />
          <line x1="-90" y1="0" x2="-84" y2="0" transform="rotate(162)" />
        </g>

        <!-- 2. LABELS DE PORCENTAJE (Con margen exterior limpio) -->
        <g class="text-[8.5px] font-bold fill-slate-400 dark:fill-slate-500" text-anchor="middle">
          <text x="-106" y="3">0%</text>
          <text x="-101" y="-30">10%</text>
          <text x="-86" y="-59">20%</text>
          <text x="-62" y="-83">30%</text>
          <text x="-33" y="-99">40%</text>
          <text x="0" y="-105">50%</text>
          <text x="33" y="-99">60%</text>
          <text x="62" y="-83">70%</text>
          <text x="86" y="-59">80%</text>
          <text x="101" y="-30">90%</text>
          <text x="108" y="3">100%</text>
        </g>

        <!-- 3. LA AGUJA CORREGIDA -->
        <!-- Ajustamos el polígono base para que apunte hacia la izquierda (-90, 0) que equivale a 0% -->
        <g :style="needleStyle" class="transition-transform duration-1000 ease-out" filter="url(#needle-shadow)">
          <!-- El vértice de la aguja ahora apunta exactamente a la longitud del arco (-84px a la izquierda) -->
          <polygon points="0,-2 -84,0 0,2" fill="#334155" class="dark:fill-slate-300" />
          <!-- Pin central -->
          <circle cx="0" cy="0" r="5" fill="#1e293b" class="dark:fill-slate-200" />
          <circle cx="0" cy="0" r="1.5" fill="#ffffff" />
        </g>
      </g>
    </svg>

    <!-- 4. INDICADORES DE TEXTO INFERIORES BAJADOS -->
    <!-- Cambiamos bottom-2 por un bloque con mt-2 fuera del flujo del SVG para evitar colisiones -->
    <div class="text-center w-full mt-2">
      <span class="text-4xl font-black tracking-tight text-slate-800 dark:text-slate-100">
        {{ percentage }}%
      </span>
      <p class="text-[11px] font-bold uppercase tracking-widest text-slate-400 dark:text-slate-500 mt-1">
        Estado: <span :class="statusTextColor">{{ statusText }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TokenGauge',
  props: {
    percentage: {
      type: Number,
      default: 40
    }
  },
  computed: {
    needleStyle() {
      // Como la aguja base ahora apunta hacia la izquierda (0%), 
      // solo rotamos en sentido horario de 0 a 180 grados proporcionalmente.
      const angle = (this.percentage / 100) * 180;
      return {
        transform: `rotate(${angle}deg)`
      };
    },
    statusText() {
      if (this.percentage >= 71) return 'Crítico';
      if (this.percentage >= 51) return 'Advertencia';
      return 'Normal';
    },
    statusTextColor() {
      return {
        'text-emerald-500': this.percentage <= 50,
        'text-amber-500': this.percentage >= 51 && this.percentage <= 70,
        'text-red-500': this.percentage >= 71
      };
    }
  }
};
</script>